export const navitems = [
    {
      id: 1,
      title: "Accueil",
      path: "./",
      cName: "nav-item"
    },
    {
      id: 2,
      title: "Actualité",
      path: "./actualite",
      cName: "nav-item"
    },
    {
      id: 3,
      title: "Immobilier",
      path: "./immobilier",
      cName: "nav-item"
    },
  
    {
      id: 5,
      title: "Mon compte",
      path: "./dash",
      cName: "nav-item"
    },
    {
      id: 6,
      title: "Contactez nous",
      path: "./contactus",
      cName: "nav-item"
    },
  
  ];

  
  
  